"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { DataSetModel } from "@/models/dataset.model";
import { Component, PropSync, Vue, Watch } from "vue-property-decorator";
let VdAdminView = class extends Vue {
  constructor() {
    super(...arguments);
    this.users_datas = [];
    this.orther_datas = [];
  }
  mounted() {
    this.reload();
  }
  reload() {
    this.users_datas = [];
    this.orther_datas = [];
    for (const item of this._users.datas) {
      if (this.users_datas.length >= 4) {
        this.orther_datas.push({
          account: item.account,
          account_no: item.user_no,
          account_guid: item.guid,
          account_name: item.name
        });
      }
      if (this.users_datas.length < 4) {
        this.users_datas.push({
          account: item.account,
          account_no: item.user_no,
          account_guid: item.guid,
          account_name: item.name
        });
      }
    }
  }
  getNo(account_no) {
    return account_no.substring(account_no.length - 2, account_no.length);
  }
  previous() {
  }
  next() {
  }
};
__decorateClass([
  PropSync("users", { type: DataSetModel, default: function() {
    return new DataSetModel();
  } })
], VdAdminView.prototype, "_users", 2);
__decorateClass([
  Watch("users")
], VdAdminView.prototype, "reload", 1);
VdAdminView = __decorateClass([
  Component
], VdAdminView);
export {
  VdAdminView as default
};
